<template>
  <v-sheet>
    Hero + Map
  </v-sheet>
</template>
<script>
export default {
  name: 'HeroicMap',
  data: () => ({
    //
  }),
  created() {
    
  }
}
</script>